import React, { useState, useEffect, useRef, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import ImageIcon from '../../assets/img/message.png';

import {
  handleInfosUser,
  getListuser,
  watchNewMessages
} from '../../store/action/internalChat';

import api from './config/configAPI';
import UserService from 'views/User/service/index';

import { useConectionSocketAdmConversation } from 'hooks/useSocketAdmConversations';
import { useConectionSocketChatInternal } from 'hooks/useInternalChatSocket';
import { useConversationConnectionSocketForMonitoring } from 'hooks/useConversationConnectionSocketForMonitoring';

import {
  Container,
  BodyChat,
  Header,
  WrapperHeaderButton,
  HeaderRow,
  ChatToggleButton,
  NotificationBadge,
  GroupCreateButton,
  StatusWrapper,
  StatusDot,
  StatusSelectorContainer,
  StatusButton,
  StatusMenu,
  StatusOption,
  StatusOptionText,
  StatusOptionLabel,
  StatusOptionDescription,
  ChevronIcon
} from './style';

import { Chat } from './chat/index';
import { UserListContainer } from './components/userList';
import { SoundSettingsModal } from './components/soundModal';
import { SoundToggleWrapper } from './components/soundModal/style';
import CreateGroupModal from './components/createGroupModal';
import GroupOptionsModal from './components/groupOptionsModal';

import { useDesktopNotifications } from './hooks/useDesktopNotifications';
import { FaUserFriends } from 'react-icons/fa';
import { verifyRoles } from 'components/Authentication/VerifyRoles';
import { SearchInput } from 'components/SearchInput/SearchInput';
import { LuSettings2 } from 'react-icons/lu';
import { HiMiniChatBubbleLeftRight } from 'react-icons/hi2';
import { HiChevronDown, HiChevronRight } from 'react-icons/hi';
import InternalChatPresenceService from './services/presenceService';

export const InternalChat = ({ sizeChat }) => {
  const [search, setSearch] = useState('');
  const { soundEnabled, setSoundEnabled } = useConectionSocketChatInternal();
  const [users, setUsers] = useState([]);
  const [usersInternalChat, setUsersInternalChat] = useState([]);
  const [userLogeds, setUsersLogeds] = useState([]);
  const [loading, setLoading] = useState(true);
  const [userConversation, setUserConversation] = useState([]);
  const [senders, setSenders] = useState([]);
  const [unreadFromUsers, setUnreadFromUsers] = useState([]);
  const [unreadGroups, setUnreadGroups] = useState([]);
  const [showSoundModal, setShowSoundModal] = useState(false);
  const [showGroupOptions, setShowGroupOptions] = useState(false);
  const [groupSelected, setGroupSelected] = useState(null);
  const [currentStatus, setCurrentStatus] = useState('available');
  const [showStatusMenu, setShowStatusMenu] = useState(false);
  const [usersStatus, setUsersStatus] = useState({});
  const [usersRawStatus, setUsersRawStatus] = useState({});
  const statusSelectorRef = useRef(null);

  const { requestPermission, showNotification } = useDesktopNotifications();
  const [showGroupModal, setShowGroupModal] = useState(false);

  const dispatch = useDispatch();
  const login = localStorage.getItem('login');

  const dataChat = useSelector((state) => state.orderListUser);
  const activeChats = useSelector((state) => state.activeChatInternal.chats);
  const systemConfiguration = useSelector((state) => state.systemConfiguration);
  const watchStateNewMessages = useSelector(
    (state) => state.activeChatInternal.newMessages
  );

  const { socketInternalChat } = useConectionSocketChatInternal();
  const { socketConversation } = useConversationConnectionSocketForMonitoring();
  const { socketAdm } = useConectionSocketAdmConversation();

  useEffect(() => {
    const service = new InternalChatPresenceService();
    let mounted = true;

    const fetchAllStatuses = () => {
      service
        .getAllStatuses()
        .then((statusMap) => {
          if (!mounted) return;
          setUsersStatus(statusMap);

          if (statusMap[login]) {
            setCurrentStatus(statusMap[login]);
          }
        })
        .catch((error) => {
          console.error('Erro ao obter status dos usuários:', error);
        });
    };

    fetchAllStatuses();

    return () => {
      mounted = false;
    };
  }, [login]);

  useEffect(() => {
    const service = new InternalChatPresenceService();
    let mounted = true;

    service
      .getStatusForUser(login)
      .then((response) => {
        if (!mounted) return;
        if (response?.status) {
          setCurrentStatus(response.status);
        }
      })
      .catch((error) =>
        console.error('Erro ao obter status do usuário:', error)
      );

    return () => {
      mounted = false;
    };
  }, [login]);

  useEffect(() => {
    requestPermission();
  }, []);

  useEffect(() => {
    const handleNewMessage = (response) => {
      const sender = response.from ?? response.sender;
      const isChatOpen = activeChats.some(
        (chat) => chat.login === sender && chat.active
      );

      if (!watchStateNewMessages && !isChatOpen) {
        setUnreadFromUsers((prev) => {
          if (!prev.includes(sender)) {
            return [...prev, sender];
          }
          return prev;
        });
      }

      if (document.hidden && sender !== login) {
        showNotification(`Chat Interno: \nNova mensagem de ${sender}`, {
          body: response.content,
          icon: ImageIcon
        });
      }
    };

    const handleGroupMessage = (response) => {
      const groupId = response.groupId;
      const sender = response.sender;
      const isGroupChatOpen = activeChats.some(
        (chat) => chat.login === groupId && chat.active
      );

      if (!isGroupChatOpen && sender !== login) {
        setUnreadGroups((prev) => {
          if (!prev.includes(groupId)) {
            return [...prev, groupId];
          }
          return prev;
        });
      }

      if (document.hidden && sender !== login) {
        // Buscar nome do grupo para a notificação
        const group = userConversation.find((g) => g.id === groupId);
        const groupName = group?.name || 'Grupo';

        // Detectar tipo de mensagem
        const isFile = !!response.source;
        const isAudio = response.type === 'audio';

        let notificationTitle = `Chat Interno: \nNova mensagem no grupo ${groupName}`;
        let notificationBody = response.content;

        if (isFile) {
          if (isAudio) {
            notificationTitle = `Chat Interno: \nNovo áudio no grupo ${groupName}`;
            notificationBody = '🎤 Áudio enviado';
          } else {
            notificationTitle = `Chat Interno: \nNovo arquivo no grupo ${groupName}`;
            notificationBody = '📎 Arquivo enviado';
          }
        }

        showNotification(notificationTitle, {
          body: notificationBody,
          icon: ImageIcon
        });
      }
    };

    socketInternalChat.on('message', handleNewMessage);
    socketInternalChat.on('group:message_receive', handleGroupMessage);
    socketInternalChat.on('group:message', handleGroupMessage);

    return () => {
      socketInternalChat.off('message', handleNewMessage);
      socketInternalChat.off('group:message_receive', handleGroupMessage);
      socketInternalChat.off('group:message', handleGroupMessage);
    };
  }, [
    socketInternalChat,
    watchStateNewMessages,
    activeChats,
    login,
    soundEnabled,
    showNotification,
    userConversation
  ]);

  function toggleNewMessage(param) {
    dispatch(watchNewMessages(param));
  }

  function handleInfosUserFunction(infos) {
    api
      .post('conversations/', {
        senderId: login,
        receiverId: infos.login
      })
      .then((response) => {
        const data = { id: response.data.id };
        dispatch(handleInfosUser(Object.assign(infos, data)));
      })
      .catch((err) => {
        console.log('error', err);
      });
  }

  function updateConversation(infos) {
    socketInternalChat.emit('chat:opened', {
      self: login,
      partnerId: infos.login,
      groupId: ''
    });

    setUnreadFromUsers((prev) => prev.filter((login) => login !== infos.login));
  }

  function updateGroupConversation(groupId) {
    socketInternalChat.emit('chat:opened', {
      self: login,
      partnerId: '',
      groupId: groupId
    });

    setUnreadGroups((prev) => prev.filter((id) => id !== groupId));
  }

  const handleOpenGroupChat = (group) => {
    const normalized = {
      ...group,
      login: group.id,
      type: 'group',
      name: group.title || group.name,
      active: true
    };
    dispatch(handleInfosUser(normalized));
    updateGroupConversation(group.id);
  };

  const getUsers = () => {
    UserService.getAllSeach(0, 0, '', false).then((response) => {
      setUsers(response.data.data);
    });
  };

  async function getConversationsList() {
    try {
      const [privateRes, groupsRes] = await Promise.all([
        api.get(`conversations?memberId=${login}`),
        api.get(`groups/${login}`)
      ]);

      const conversations = privateRes.data.conversations.map((item) => {
        const lastUpdate = item.lastMessage;
        return {
          id: item.id,
          sender: item.members[0] === login ? item.members[1] : item.members[0],
          updatedAt: lastUpdate?.createdAt || null,
          type: 'private',
          ...item
        };
      });

      const groups = (groupsRes.data.groups || []).map((group) => {
        return {
          id: group.id,
          name: group.title,
          updatedAt: group.lastMessage?.createdAt || group.updatedAt || null,
          type: 'group',
          ...group
        };
      });

      const allChats = [...conversations, ...groups];

      setUserConversation(allChats);

      const senders = conversations.map((c) => c.sender);
      setSenders(senders);
    } catch (error) {
      console.error('Erro no getConversation =>', error);
    }
  }

  useEffect(() => {
    getUsers();
  }, []);

  useEffect(() => {
    api
      .get(`/user/${login}`)
      .then((res) => setSoundEnabled(res.data.isSoundInternalChat))
      .catch((err) =>
        console.error('Erro ao buscar configurações de som:', err)
      );
  }, []);

  useEffect(() => {
    if (!userLogeds.length && Array.isArray(dataChat.chats)) {
      setUsersLogeds(dataChat.chats);
    }

    getConversationsList();
  }, [dataChat]);

  useEffect(() => {
    if (!socketConversation) return;

    const onLogged = (data) => {
      const atendentes = data?.atendentes || [];

      const normalized = atendentes.map((a) => ({
        login: a.login ?? a.user ?? a.username ?? a
      }));

      setUsersLogeds(normalized);

      dispatch(getListuser(atendentes));
    };

    socketConversation.emit('lista_atendentes_logados');
    socketConversation.on('atendentes_logados', onLogged);

    return () => {
      socketConversation.off('atendentes_logados', onLogged);
    };
  }, [socketConversation, dispatch]);

  useEffect(() => {
    if (!socketInternalChat) return;

    const onOnlineChanged = ({ user, isOnline }) => {
      if (!user || typeof isOnline !== 'boolean') return;

      setUsersLogeds((prev) => {
        const exists = prev.some((u) => u.login === user);

        if (isOnline) {
          if (exists) return prev;
          return [...prev, { login: user }];
        }

        if (!exists) return prev;
        return prev.filter((u) => u.login !== user);
      });
    };

    socketInternalChat.on('online:changed', onOnlineChanged);

    return () => {
      socketInternalChat.off('online:changed', onOnlineChanged);
    };
  }, [socketInternalChat]);

  useEffect(() => {
    if (!socketInternalChat) return;
    const service = new InternalChatPresenceService();

    const refreshFromBackend = () => {
      service
        .getAllStatuses()
        .then((statusMap) => {
          setUsersStatus(statusMap);

          setUsersRawStatus((prev) => {
            const next = { ...prev };
            Object.entries(statusMap).forEach(([user, status]) => {
              next[user] = {
                isOnline: status !== 'away',
                isBusy: status === 'busy'
              };
            });
            return next;
          });

          if (statusMap[login]) {
            setCurrentStatus(statusMap[login]);
          }
        })
        .catch((err) =>
          console.error('Erro ao sincronizar status após login:', err)
        );
    };

    socketInternalChat.on('connect', refreshFromBackend);

    return () => {
      socketInternalChat.off('connect', refreshFromBackend);
    };
  }, [socketInternalChat, login]);

  useEffect(() => {
    const onUserStatusChanged = ({ user, isOnline, isBusy, timestamp }) => {
      setUsersRawStatus((prev) => {
        const current = prev[user] || { isOnline: true, isBusy: false };
        const updated = {
          isOnline: isOnline !== undefined ? isOnline : current.isOnline,
          isBusy: isBusy !== undefined ? isBusy : current.isBusy
        };

        setUsersStatus((statusMap) => {
          const newStatus = !updated.isOnline
            ? 'away'
            : updated.isBusy
            ? 'busy'
            : 'available';
          return {
            ...statusMap,
            [user]: newStatus
          };
        });

        return {
          ...prev,
          [user]: updated
        };
      });
    };

    socketInternalChat.on('user:status-changed', onUserStatusChanged);

    return () => {
      socketInternalChat.off('user:status-changed', onUserStatusChanged);
    };
  }, [socketInternalChat]);

  useEffect(() => {
    if (!socketConversation) return;

    const refresh = () => socketConversation.emit('lista_atendentes_logados');

    refresh();
    const t = setInterval(refresh, 15000);

    return () => clearInterval(t);
  }, [socketConversation]);

  useEffect(() => {
    const format = users.map((user) => {
      const isLogged = userLogeds.some((u) => u.login === user.login);
      return { ...user, isLogged };
    });
    setUsersInternalChat(format);
  }, [userLogeds, users]);

  useEffect(() => {
    socketInternalChat.on('message', (response) => {
      const isChatOpen = activeChats.some(
        (chat) => chat.login === response.from && chat.active
      );

      if (!watchStateNewMessages && !isChatOpen) {
        setUnreadFromUsers((prev) => {
          if (!prev.includes(response.from ?? response.sender)) {
            return [...prev, response.from ?? response.sender];
          }
          return prev;
        });
      }
    });

    socketInternalChat.on('group:message_receive', (response) => {
      const groupId = response.groupId;
      const sender = response.sender;
      const isGroupChatOpen = activeChats.some(
        (chat) => chat.login === groupId && chat.active
      );

      if (!watchStateNewMessages && !isGroupChatOpen && sender !== login) {
        setUnreadGroups((prev) => {
          if (!prev.includes(groupId)) {
            return [...prev, groupId];
          }
          return prev;
        });
      }
    });
  }, [socketInternalChat, watchStateNewMessages, activeChats, login]);

  useEffect(() => {
    if (!socketInternalChat) return;

    const asListItem = (g) => ({
      id: g.id ?? g.groupId,
      name: g.name ?? g.title,
      picture: g.picture,
      updatedAt:
        g.lastMessage?.createdAt || g.updatedAt || new Date().toISOString(),
      type: 'group',
      ...g
    });

    const addGroupToList = (group) => {
      const item = asListItem(group || {});
      if (!item?.id) {
        getConversationsList();
        return;
      }

      if (group?.members) {
        item.members = group.members;
      }

      setUserConversation((prev) => {
        if (prev.some((x) => x.id === item.id)) return prev;
        return [item, ...prev];
      });
    };

    const onCreateSuccess = (group) => addGroupToList(group);

    socketInternalChat.on('group:create:success', onCreateSuccess);
    socketInternalChat.on('group:created', onCreateSuccess);

    return () => {
      socketInternalChat.off('group:create:success', onCreateSuccess);
      socketInternalChat.off('group:created', onCreateSuccess);
    };
  }, [socketInternalChat]);

  useEffect(() => {
    const onRefresh = () => getConversationsList();
    window.addEventListener('internalchat:groups:refresh', onRefresh);
    return () =>
      window.removeEventListener('internalchat:groups:refresh', onRefresh);
  }, []);

  useEffect(() => {
    const onOpenOptions = (e) => {
      setGroupSelected(e.detail?.group || null);
      setShowGroupOptions(true);
    };
    window.addEventListener('internalchat:group:options', onOpenOptions);
    return () =>
      window.removeEventListener('internalchat:group:options', onOpenOptions);
  }, []);

  const statusColorMap = {
    available: '#21c25e',
    busy: '#e53935',
    away: '#9e9e9e'
  };

  const statusLabelMap = {
    available: 'Disponível',
    busy: 'Ocupado',
    away: 'Ausente'
  };

  const statusOptions = [
    {
      value: 'available',
      label: 'Disponível',
      description: 'Você está visível para todos.',
      color: statusColorMap.available
    },
    {
      value: 'busy',
      label: 'Ocupado',
      description: 'Você não quer ser interrompido.',
      color: statusColorMap.busy
    },
    {
      value: 'away',
      label: 'Ausente',
      description: 'Você está ausente.',
      color: statusColorMap.away
    }
  ];

  const statusColor = statusColorMap[currentStatus] || statusColorMap.away;
  const statusLabel = statusLabelMap[currentStatus] || statusLabelMap.away;

  const handleStatusChange = (value) => {
    const service = new InternalChatPresenceService();

    service
      .updateStatus(login, value)
      .then((result) => {
        if (result.success) {
          setCurrentStatus(value);
        } else {
          console.error('Falha ao atualizar status');
        }
      })
      .catch((error) => {
        console.error('Erro ao atualizar status:', error);
      });

    setShowStatusMenu(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!statusSelectorRef.current) return;
      if (!statusSelectorRef.current.contains(event.target)) {
        setShowStatusMenu(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const totalUnreadMessages = useMemo(() => {
    return userConversation.reduce((total, conv) => {
      const isUnread =
        (conv.type === 'private' && unreadFromUsers.includes(conv.sender)) ||
        (conv.type === 'group' && unreadGroups.includes(conv.id));

      return total + (isUnread ? conv.newMessagesCount || 0 : 0);
    }, 0);
  }, [userConversation, unreadFromUsers, unreadGroups]);

  useEffect(() => {
    let baseTitle = document.title.replace(/^\(\d+\)\s*/, '').trim();

    if (totalUnreadMessages > 0) {
      document.title = `(${totalUnreadMessages}) ${baseTitle}`;
    } else {
      document.title = baseTitle;
    }

    return () => {
      document.title = baseTitle;
    };
  }, [totalUnreadMessages]);

  return (
    <Container>
      <BodyChat sizeChat={sizeChat}>
        <Header
          color={systemConfiguration.primary_color}
          fontColor={systemConfiguration.internal_chat_font_color}
        >
          <WrapperHeaderButton>
            <HeaderRow>
              {watchStateNewMessages &&
                verifyRoles(['CREATE_GROUP_INTERNAL_CHAT']) && (
                  <GroupCreateButton
                    title="Criar grupo"
                    onClick={() => setShowGroupModal(true)}
                  >
                    <FaUserFriends size={18} />
                  </GroupCreateButton>
                )}

              <ChatToggleButton
                onClick={() => toggleNewMessage(!watchStateNewMessages)}
              >
                <HiMiniChatBubbleLeftRight size={18} />
                <StatusWrapper>
                  <span>Chat interno</span>
                </StatusWrapper>
                <ChevronIcon isOpen={!watchStateNewMessages}>
                  <HiChevronDown size={18} color="white" />
                </ChevronIcon>
              </ChatToggleButton>

              <SoundToggleWrapper>
                <LuSettings2
                  color="white"
                  onClick={() => setShowSoundModal((prev) => !prev)}
                />

                <SoundSettingsModal
                  show={showSoundModal}
                  soundEnabled={soundEnabled}
                  setSoundEnabled={setSoundEnabled}
                  login={login}
                />
              </SoundToggleWrapper>

              {!watchStateNewMessages &&
                (unreadFromUsers.some(
                  (login) => login !== localStorage.getItem('login')
                ) ||
                  unreadGroups.length > 0) && (
                  <NotificationBadge>
                    {(() => {
                      const privateUnreadCount = userConversation
                        .filter(
                          (conv) =>
                            conv.type === 'private' &&
                            unreadFromUsers.includes(conv.sender)
                        )
                        .reduce(
                          (sum, conv) => sum + (conv.newMessagesCount || 0),
                          0
                        );

                      const groupUnreadCount = userConversation
                        .filter(
                          (conv) =>
                            conv.type === 'group' &&
                            unreadGroups.includes(conv.id)
                        )
                        .reduce(
                          (sum, conv) => sum + (conv.newMessagesCount || 0),
                          0
                        );

                      return privateUnreadCount + groupUnreadCount;
                    })()}
                  </NotificationBadge>
                )}
            </HeaderRow>

            <StatusSelectorContainer ref={statusSelectorRef}>
              <StatusButton
                onClick={(e) => {
                  e.stopPropagation();
                  if (watchStateNewMessages === false) toggleNewMessage(true);

                  setShowStatusMenu((prev) => !prev);
                }}
                aria-expanded={showStatusMenu}
                aria-haspopup="listbox"
              >
                <StatusDot color={statusColor} />
                <span>{statusLabel}</span>
                <HiChevronRight size={16} color="white" />
              </StatusButton>

              {showStatusMenu && (
                <StatusMenu role="listbox" aria-label="Status do usuário">
                  {statusOptions.map((option) => (
                    <StatusOption
                      key={option.value}
                      onClick={() => handleStatusChange(option.value)}
                      role="option"
                      aria-selected={currentStatus === option.value}
                    >
                      <StatusDot color={option.color} />
                      <StatusOptionText>
                        <StatusOptionLabel>{option.label}</StatusOptionLabel>
                        <StatusOptionDescription>
                          {option.description}
                        </StatusOptionDescription>
                      </StatusOptionText>
                    </StatusOption>
                  ))}
                </StatusMenu>
              )}
            </StatusSelectorContainer>
          </WrapperHeaderButton>
        </Header>

        <SearchInput
          placeholder="Buscar..."
          setSearch={setSearch}
          search={search}
          searchChatsZoneStyle={{
            padding: '.6rem',
            background: '#f7f8fd'
          }}
          searchChatsInputStyle={{
            borderRadius: '6px'
          }}
        />

        <UserListContainer
          search={search}
          sizeChat={watchStateNewMessages}
          handleInfosUserFunction={handleInfosUserFunction}
          handleOpenGroupChat={handleOpenGroupChat}
          updateConversation={updateConversation}
          users={usersInternalChat}
          usersStatus={usersStatus}
          color={systemConfiguration.primary_color}
          loading={loading}
          setLoading={setLoading}
          userConversation={userConversation}
          senders={senders}
          unreadFromUsers={unreadFromUsers}
          unreadGroups={unreadGroups}
        />
      </BodyChat>

      <Chat
        unreadFromUsers={unreadFromUsers}
        setUnreadFromUsers={setUnreadFromUsers}
        unreadGroups={unreadGroups}
        setUnreadGroups={setUnreadGroups}
      />

      <CreateGroupModal
        isOpen={showGroupModal}
        onClose={() => setShowGroupModal(false)}
        headerColor={systemConfiguration.primary_color}
        headerFontColor={systemConfiguration.internal_chat_font_color}
      />

      <GroupOptionsModal
        isOpen={showGroupOptions}
        onClose={() => setShowGroupOptions(false)}
        group={groupSelected}
        theme={{
          primary_color: systemConfiguration.primary_color,
          internal_chat_font_color: systemConfiguration.internal_chat_font_color
        }}
        currentUser={{ login: localStorage.getItem('login') }}
        socket={socketInternalChat}
        onGroupUpdate={(updatedGroup) => {
          if (updatedGroup.removed) {
            setUserConversation((prev) =>
              prev.filter((conversation) => conversation.id !== updatedGroup.id)
            );
          } else {
            setUserConversation((prev) =>
              prev.map((conversation) =>
                conversation.id === updatedGroup.id
                  ? { ...conversation, ...updatedGroup }
                  : conversation
              )
            );
          }
          setShowGroupOptions(false);
        }}
      />
    </Container>
  );
};
